import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCXP() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Pagos", items: [
      { label: "Pagos y Saldos", icon: "fas fa-hand-holding-usd", color: "#ea580c", href: "/PagosCxp", enabled: !!(user.menu_adminCxP || user.menu_cxpPagos) },
    ]},
    { section: "Proveedores", items: [
      { label: "Compras", icon: "fas fa-money-check-alt", color: "#2563eb", href: "/ListadoComprasCXP", enabled: !!(user.menu_adminCxP) },
      { label: "Abonos Proveedores", icon: "fas fa-dollar-sign", color: "#2563eb", href: "/ListadoAbonosProveedores", enabled: !!(user.menu_adminCxP) },
      { label: "Estado Cuenta Proveedores", icon: "fas fa-file-invoice-dollar", color: "#2563eb", href: "/EstadoCuentaCXP", enabled: !!(user.menu_adminCxP) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#2563eb", href: "/ListadoDevolucionesProveedoresadmin", enabled: !!(user.menu_adminCxP) },
      { label: "Antiguedad Saldos Proveedores", icon: "fas fa-chart-line", color: "#2563eb", href: "/AntiguedadSaldosVencidoProveedores", enabled: !!((user.menu_adminCxP || user.menu_cxpPagos) && user.menu_reportes) },
    ]},
    { section: "Talleres", items: [
      { label: "Notas Talleres", icon: "fas fa-money-check-alt", color: "#0d9488", href: "/ListadoNotasCXP", enabled: !!(user.menu_adminCxP) },
      { label: "Abonos Talleres", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/ListadoAbonosMaquileros", enabled: !!(user.menu_adminCxP) },
      { label: "Estado Cuenta Talleres", icon: "fas fa-file-invoice-dollar", color: "#0d9488", href: "/EstadoCuentaMaq", enabled: !!(user.menu_adminCxP) },
      { label: "Anticipos Talleres", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/ListadoAnticiposProveedores", enabled: !!(user.menu_adminCxP) },
      { label: "Aplicar Faltantes", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/ListadoFaltantesProveedores", enabled: !!(user.menu_adminCxP) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="CxP"
      descripcion="Pagos a proveedores y talleres"
      icono="fas fa-hand-holding-usd"
      color="#ea580c"
      secciones={secciones}
    />
  );
}

export default BotonesCXP;
